export const toSnakeCase = (str: string): string =>
  str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();

export const toUrlEncoded = (obj: any): string =>
  Object.keys(obj)
    .map((k) => `${encodeURIComponent(toSnakeCase(k))}=${encodeURIComponent(obj[k])}`)
    .join('&');

export const isEmpty = (value: any): boolean =>
  value === undefined
  || value === null
  || (typeof value === 'object' && Object.keys(value).length === 0)
  || (typeof value === 'string' && value.trim().length === 0);
